<template>
  <div class="full-height">
    <crud-layout-search
      ref="crudLayoutSearch"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :noneselect="true"
      :pageTable="pageTable"
      :row-buttons="true"
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ServiceReportPageTable from './ServiceReportPageTable.vue'
import { repository, messageBox, downloadFile } from 'jtech'
import { __downloadFile } from 'src/shared/global/UtilFile'

const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'ServiceReport',
  components: { CrudLayoutSearch, ServiceReportPageTable },
  props: {
    name: String,
    id: String
  }
})
class ServiceReport extends Vue {
  nmInterface = 'serviceReport.pesquisar'

  get pageTable () {
    return ServiceReportPageTable
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('exportCSV', this.exportCSV)
      this.$refs.crudLayoutSearch.onButton('btPesquisar', this.handlePesquisar)
    } catch (error) {
      console.error(error)
    }
  }

  async handlePesquisar ({ button, params, page }) {
    const crudLayout = this.$refs.crudLayoutSearch
    const cleanedParams = this.cleanSearchParams(params)

    if (page) {
      if (crudLayout && crudLayout.state && crudLayout.state.containers) {
        const stateKey = crudLayout.stateKeyComputed
        crudLayout.state.containers[stateKey].searchParams = { ...cleanedParams }
        crudLayout.searchParams = crudLayout.state.containers[stateKey].searchParams
      } else {
        crudLayout.searchParams = { ...cleanedParams }
      }
      crudLayout.refresh()
      if (crudLayout.flModal !== undefined) crudLayout.flModal = false
      return
    }

    if (crudLayout && typeof crudLayout.actionButtonDefault === 'function') {
      return crudLayout.actionButtonDefault(button, cleanedParams, page)
    }

    return null
  }

  cleanSearchParams (params) {
    if (!params || typeof params !== 'object') return params
    const cleaned = { ...params }

    Object.keys(cleaned).forEach((key) => {
      const value = cleaned[key]
      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        Object.keys(value).length > 0
      ) {
        const allEmpty = Object.values(value).every((item) =>
          item === null || item === undefined || item === '' ||
          (typeof item === 'object' && item !== null && Object.keys(item).length === 0)
        )
        if (allEmpty) {
          cleaned[key] = null
        }
      }
    })

    return cleaned
  }

  async exportCSV () {
    try {
      const crudLayout = this.$refs.crudLayoutSearch

      const filters = this.$refs.crudLayoutSearch.searchParams || {}

      if (!filters.startDate || !filters.startDate.inicial || !filters.startDate.final) {
        messageBox.error(this.$gettext('REQUIRED_DATA_FILTER'))
        return
      }

      const interfaceReport = 'serviceReport.reportCSV'
      const startDateInicial = filters.startDate?.inicial
      const startDateFinal = filters.startDate?.final
      const classification = filters?.serviceClassification
      const type = filters?.serviceType
      const origin = filters?.serviceOrigin
      const attendant = filters?.serviceAttendant

      const response = await repository.resolveLogic(interfaceReport, {
        startDateInicial: startDateInicial,
        startDateFinal: startDateFinal,
        classification: classification,
        type: type,
        origin: origin,
        attendant: attendant,
        grid: 'csvAnalytical'
      })
      this.downloadCsv(response.nmArquivo)
      messageBox.success(this.$gettext('EXPORT_CSV_SUCESS'))
    } catch (error) {
      console.error(error)
      messageBox.error(this.$gettext('EXPORT_CSV_ERROR') + error.message)
    }
  }

  async downloadCsv (nmArquivo) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo
      )
      this.fileSrc = URL.createObjectURL(result)

      this.$nextTick(() => {
        __downloadFile(this.fileSrc, 'RelatorioDeAtendimento', '.csv')
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default ServiceReport
</script>

<style scoped>
</style>
